import {IUpdateDisclosureRequest} from "./IUpdateDisclosureRequest";

export class UpdateSpecifiedDisclosureRequest implements IUpdateDisclosureRequest{
    caseId: number;
    questionCode: string;
    disclosureAlias: string;
    disclosureValue: string;

    constructor() {
        this.caseId = 0;
        this.questionCode = '';
        this.disclosureAlias = '';
        this.disclosureValue = '';
    }
}
